import React from 'react';
export default class RowItemDanhSachDoanDongNguoi extends React.Component {

  render() {
    return (
      <tr>
        <td style={{textAlign: 'center'}}>{this.props.count}</td>
        <td>{this.props.item.hoVaTen}</td>
        <td>{this.props.item.cmndHoChieu}</td>
        <td>{this.props.item.diaChi}</td>
        <td>{this.props.item.soDienThoai}</td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/modules/giai-quyet-don/datatable/rowItem/RowItemDanhSachDoanDongNguoi.jsx